<!-- @format -->

<div class="yearAtAGlanceHeader">
  <div class="yearDisplay">
    <button type="button" class="btn-year" [disabled]="!hasPreviousYear()" (click)="goToPreviousYear()" title="previous year">
      <i class="fa-solid fa-chevron-left"></i>
    </button>

    <span class="yearNumber">{{selectedYear}}</span>

    <button type="button" class="btn-year" [disabled]="!hasNextYear()" (click)="goToNextYear()" title="next year">
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </div>

  <div class="btnContainer">
    <button class="filterBtn" (click)="open(filtersPanel)">
      <i class="fa-regular fa-sliders"></i>
      Filters
    </button>
  </div>

  <!-- <app-time-bank
  [bankTypes]="(bankTypes$ | async)"
  [timeBanks]="(timeBanks$ | async)"
  [selectedYear]="(selectedYear$ | async)"
  [currentPayPeriod]="currPayPeriod"
  [lastPayPeriod]="lastPayPeriod"
  [timesheets]="timesheets"
  [profile]="(profile$ | async)"
[exceptionTypes]="(exceptionTypes$ | async)"></app-time-bank> -->
</div>

<div class="allMonthsContainer">
  @for (e of [].constructor(12); track 'month' + i; let i = $index) {
    <div class="calenderDisplay" [class.decemberPadding]="i === 11">
      <app-calendar
        [isYearView]="true"
        [calendarData]="extractMonthlyData(i)"
        [filterToggleStates]="filterToggleStates"
      (handleRedirectToTimesheet)="handleRedirectToTimesheet($event)"></app-calendar>
    </div>
  }
</div>

<ng-template #filtersPanel let-offcanvas>
  <div id="filterPanel">
    <div class="offcanvas-body">
      <div class="panelContent">
        <div class="panelTitle">Filters</div>
        <div class="filterToggles">
          <div class="toggleRow">
            <div class="icon payPeriod"></div>
            <div class="filterType">Pay period</div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.payPeriod" />
                <i></i>
              </label>
            </div>
          </div>

          <div class="toggleRow">
            <div class="icon">
              <div class="triangle triangle_tl_small"></div>
            </div>
            <div class="filterType">Pay day</div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.payDay" />
                <i></i>
              </label>
            </div>
          </div>

          <div class="toggleRow">
            <div class="icon stat"></div>
            <div class="filterType">Statutory holiday (Observed)</div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.statHoliday" />
                <i></i>
              </label>
            </div>
          </div>

          <div class="toggleRow">
            <div class="icon">
              <div class="triangle triangle_tr_small"></div>
            </div>
            <div class="filterType">Holiday Closure</div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.holidayClosure" />
                <i></i>
              </label>
            </div>
          </div>

          <div class="toggleRow">
            <div class="icon">
              <div class="cdo_small"></div>
            </div>
            <div class="filterType">Compressed Day Off (CDO)</div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.cdo" />
                <i></i>
              </label>
            </div>
          </div>

          <div class="toggleRow">
            <div class="icon">
              <div class="calendarBar"></div>
            </div>
            <div class="filterType">
              Timesheets
              <div class="subtext">Hover over date for detailed time breakdown</div>
            </div>
            <div class="toggleSwitch">
              <label class="form-switch">
                <input type="checkbox" [(ngModel)]="unAppliedFilterToggleStates.timesheets" />
                <i></i>
              </label>
            </div>
          </div>
        </div>

        <div class="applyChangesBtnContainer">
          <button class="applyChangesBtn" (click)="applyFilterPanelChanges()">Apply</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
